export enum ReportPeriodType {
  Custom = 0,
  CalendarYear = 1,
  FirstQuarter = 2,
  SecondQuarter = 3,
  ThirdQuarter = 4,
  FourthQuarter = 5
}
